import { render, staticRenderFns } from "./sessions-list.vue?vue&type=template&id=185d9e36"
import script from "./sessions-list.vue?vue&type=script&lang=js"
export * from "./sessions-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports